/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Vekn_Link_SubmitInputs */



/**
* | output |
* | --- |
* | "Link" |
*
* @param {Vekn_Link_SubmitInputs} inputs
* @param {{ locale?: "en" | "fr" | "es" | "pt" | "it" }} options
* @returns {LocalizedString}
*/
export const vekn_link_submit = /** @type {((inputs?: Vekn_Link_SubmitInputs, options?: { locale?: "en" | "fr" | "es" | "pt" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Vekn_Link_SubmitInputs, { locale?: "en" | "fr" | "es" | "pt" | "it" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Lier")
	if (locale === "es") return /** @type {LocalizedString} */ ("Vincular")
	if (locale === "pt") return /** @type {LocalizedString} */ ("Vincular")
	if (locale === "it") return /** @type {LocalizedString} */ ("Collega")
	return /** @type {LocalizedString} */ ("Link")
});